<template>
  <block-view>
    <a-typography-title :level="5">我的活动</a-typography-title>
  </block-view>
</template>

<script setup lang="ts">

import BlockView from "@/views/share/BlockView.vue";
</script>

<style scoped lang="sass">

</style>